<template>
  <div>
    <top-header></top-header>
    <el-button
      type="primary"
      icon="el-icon-plus" style="margin-top: 10px;margin-left: 20px"
      @click="handleAddMessage">推送消息</el-button>
    <div class="table_container">
      <el-table
        :data="dataList"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        style="width: 100%">
        <el-table-column
          label="内容"
          prop="Msg">
        </el-table-column>
        <el-table-column
          label="发布人" width="200"
          prop="CreateUser">
        </el-table-column>
        <el-table-column width="200"
          label="发布时间"
          prop="CreateTime">
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handleDeleteMessage(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="推送消息" :visible.sync="dialogAddMessageVisible">
      <el-form :model="addMessageModel">
        <el-form-item label="内容" label-width="100px">
          <el-input v-model="addMessageModel.Message"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <div style="padding-top: 10px;padding-left: 30px">
        <el-button @click="dialogAddMessageVisible = false">取 消</el-button>
        <el-button type="primary" @click="addMessageOkBtnClick">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TopHeader from '../../components/TopHeader'
export default {
  name: 'AdminMessage',
  components: {TopHeader},
  data () {
    return {
      dataList: [],
      currentPage: 1,
      pageCount: 10,
      totalCount: 0,
      dialogAddMessageVisible: false,
      addMessageModel: {}
    }
  },
  watch: {
    '$route': {
      handler (route) {
        const that = this
        if (route.path === '/messageop') {
          console.log('----', route.path)
          that.getMessageList()
        }
      },
      deep: true
    }
  },
  created () {
    this.getMessageList()
  },
  methods: {
    getMessageList () {
      let requestData = {count: this.pageCount, page: this.currentPage}
      this.$api.adminMessage.getMessageList(requestData).then((res) => {
        if (res.code === 0) {
          this.dataList = res.data
          this.totalCount = res.count
        }
      })
    },
    handleAddMessage () {
      this.$api.home.interCheck().then((res) => {

      })
      this.dialogAddMessageVisible = true
    },
    handleDeleteMessage (idnex, row) {
      let alertStr = '确定要删除这条消息吗？'
      this.$confirm(alertStr, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let requestData = {id: row.Id}
        this.$api.adminMessage.delMessage(requestData).then((res) => {
          if (res.code === 0) {
            this.getMessageList()
          }
        })
      }).catch(() => {

      })
    },
    handleSizeChange (val) {
      this.pageCount = val
      this.currentPage = 1
      this.getMessageList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getMessageList()
    },
    addMessageOkBtnClick () {
      let requestData = {msg: this.addMessageModel.Message}
      this.$api.adminMessage.addMessage(requestData).then((res) => {
        if (res.code === 0) {
          this.dialogAddMessageVisible = false
          this.addMessageModel = {}
          this.getMessageList()
        }
      })
    }
  }
}
</script>

<style scoped>
  .table_container{
    padding: 20px;
  }
  .Pagination{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/page/adminMessage/AdminMessage.vue